export function fullscreen(ref: string) {
  if (document.fullscreenElement) {
    document.exitFullscreen()
      .then(function () {
      })
      .catch(function (error) {
        console.log(error.message);
      });
  } else {
    var element = document.querySelector(ref);
    if (!element) return
    element.requestFullscreen()
      .then(function () {
      })
      .catch(function (error) {
        console.log(error.message);
      });
  }
}